import AnalogModal from './AnalogModal';

export default AnalogModal;
